import { useEffect, useState } from "react";
import { Col, Container, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import { useGetMyPmxActivitiesFavoritesQuery } from "../../backend/hooks/pmxActivity/favorite/queryGetMyPmxActivitiesFavorites";
import { PmxActivity } from "../../backend/types";
import Error from "../abstractComponents/error";
import { ListActivities } from "./listActivities";
import UserManualLink from "../abstractComponents/usermanual";
import { Link } from "react-router-dom";
import { LandingPageInteractiveEnvironments } from "../interactive/landingPageInteractiveEnvironments";
import { LandingPageExecutionJobs } from "../execution/landingPageExecutionJobs";

// landing page for the authenticated user
export default function LandingPage() {
  const [selectedActivity, setSelectedActivity] = useState<PmxActivity | null>(
    null
  );

  useEffect(() => {
    document.title = "PHIL App - My PHIL Home";
  }, []);

  const {
    favoriteActivities,
    errorFavoriteActivities,
    favoriteActivitiesLoading,
    isRetrying
  } = useGetMyPmxActivitiesFavoritesQuery();

  return (
    <div className="app_content">
      {favoriteActivitiesLoading && (
        <div className="center_div">
          <Spinner animation="border" className="spinner_color" />
          <p>{isRetrying ? "Retrying..." : "Loading..."}</p>
        </div>
      )}
      {!favoriteActivitiesLoading && !errorFavoriteActivities && (
        <Container fluid>
          <Row>
            <h2 className="mb-0">My PHIL Home</h2>
          </Row>
          <hr />
          <Row>
            <Col xs={10}>
              <div className="d-inline-flex">
                <h5>My Favorite Activities</h5>
                <UserManualLink
                  url="/usermanual/concepts/general_concepts/#activities"
                  testId="um-activities"
                />
              </div>
            </Col>
          </Row>
          <Row>
            {favoriteActivities && favoriteActivities.length > 0 ? (
              <ListActivities
                activities={favoriteActivities}
                onSelectedActivityChange={setSelectedActivity}
              />
            ) : (
              <p>
                No favorite activities found please add some from the{" "}
                <Link to="/activities">activities</Link> page
              </p>
            )}
          </Row>
          <Row>
            <Tabs
              defaultActiveKey="interactive"
              id="landing-page-tabs"
              className="mb-3"
              mountOnEnter
              unmountOnExit
            >
              <Tab eventKey="interactive" title="Interactive">
                <h5>My Interactive Environments</h5>
                <LandingPageInteractiveEnvironments
                  activityId={
                    selectedActivity ? Number(selectedActivity.id) : undefined
                  }
                />
              </Tab>
              <Tab
                eventKey="execution"
                title="Execution"
                mountOnEnter
                unmountOnExit
              >
                <h5>My Execution Jobs</h5>
                <LandingPageExecutionJobs
                  activityId={
                    selectedActivity ? Number(selectedActivity.id) : undefined
                  }
                />
              </Tab>
            </Tabs>
          </Row>
        </Container>
      )}
      {errorFavoriteActivities && <Error error={errorFavoriteActivities} />}
    </div>
  );
}
